export default __webpack_public_path__ + "static/media/logoWhite.3d448d1b.png";